/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Mode_CropInputs */

const cs_property_ai_mode_crop = /** @type {(inputs: Property_Ai_Mode_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ořez`)
};

const en_property_ai_mode_crop = /** @type {(inputs: Property_Ai_Mode_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crop`)
};

/**
* | output |
* | --- |
* | "Crop" |
*
* @param {Property_Ai_Mode_CropInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_mode_crop = /** @type {((inputs?: Property_Ai_Mode_CropInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Mode_CropInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_mode_crop(inputs)
	return cs_property_ai_mode_crop(inputs)
});